import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'trMsToMin', standalone: false })
export class MsToMinPipe implements PipeTransform {
  transform(value: number): number {
    const msPerMin = 60000;
    return Math.round(value / msPerMin);
  }
}
